// Central contact + CTA configuration for The Accounting Prep Club
export const WHATSAPP_SIGNUP_URL =
  'https://wa.me/27640639721?text=Hi%2C%20I%27d%20like%20to%20sign%20up%20to%20The%20Accounting%20Prep%20Club.';
export const WHATSAPP_URL = 'https://wa.me/27640639721';
export const CONTACT_PHONE_DISPLAY = '064 063 9721';
export const CONTACT_EMAIL = 'mr.r@theaccountingprepclub.co.za';

export const SOCIAL = {
  facebook: 'https://www.facebook.com/TheAccountingPrepClub',
  tiktok: 'https://www.tiktok.com/@the.accounting.pr3',
  youtube: 'https://www.youtube.com/@TheAccountingPrepClub',
};

export const BRAND = {
  name: 'The Accounting Prep Club',
  short: 'APC',
  tagline: 'Affordable Online Tutoring for Grades 4–12',
};
